@if(dialogContext.data; as data){
<dashboard-dialog-frame class="angular-form-dialog" [header]='data.header' [actions]="actions" [dialogRef]="dialogRef">

	<div class="d-flex flex-column gap-2 p-3">
		@for(field of fields; track field.formFieldName){
		@switch(field.kind){

		@case('text'){<angular-text-field [field]="field" />}

		@case('number'){<angular-number-field [field]="field" /> }

		@case('date'){<p>Date field not implemented yet!!</p> }

		@case('select'){<angular-select-field [field]="field" /> }

		@case('address'){<angular-address-field [field]="field" /> }
		}
		}
	</div>
</dashboard-dialog-frame>
}